import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './features/auth/helpers/auth.guard';

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () =>
            import('./features/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: '',
        loadChildren: () =>
            import('./features/dashboard/dashboard.module').then(
                (m) => m.DashboardModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'agencias',
        loadChildren: () =>
            import('./features/agencies/agencies.module').then(
                (m) => m.AgenciesModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'prestadores',
        loadChildren: () =>
            import('./features/providers/providers.module').then(
                (m) => m.ProvidersModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'actividades',
        loadChildren: () =>
            import('./features/activities/activities.module').then(
                (m) => m.ActivitiesModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'reservas',
        loadChildren: () =>
            import('./features/bookings/bookings.module').then(
                (m) => m.BookingsModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'administracion',
        loadChildren: () =>
            import('./features/administration/administration.module').then(
                (m) => m.AdministrationModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'transportes',
        loadChildren: () =>
            import('./features/transports/transports.module').then(
                (m) => m.TransportsModule
            ),
        canActivate: [AuthGuard]
    },
    {
        path: 'usuarios',
        loadChildren: () =>
            import('./features/users/users.module').then(
                (m) => m.UsersModule
            ),
        canActivate: [AuthGuard]
    },
    
];


@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
